/* No analytics, cookies or cart interception. UI improvements scoped to the test section. */
(() => {
  if (window.__spintzProductTestUI) return;
  window.__spintzProductTestUI = true;
  const controllers = new WeakMap();
  function init(root) {
    if (controllers.has(root)) return;
    const abort = new AbortController();
    controllers.set(root, abort);
    const sectionId = root.dataset.sectionId;
    root.querySelectorAll('[data-sp-format-pack]').forEach(label => {
      label.textContent = label.textContent.replace(/(\d)\s*(kg|mg|g|ml|l)\b/gi, '$1\u00a0$2');
    });
    root.querySelectorAll('.x-variant-picker legend').forEach(legend => {
      if (/^(Größe|Packungsgrößen?)$/i.test(legend.textContent.trim())) {
        legend.textContent = 'Packungsgröße';
      }
    });
    const notice = document.createElement('p');
    notice.hidden = true;
    notice.dataset.spVariantError = '';
    notice.setAttribute('role', 'alert');
    const content = root.querySelector('.x-block-buy-buttons');
    if (content) content.prepend(notice);
    document.addEventListener('spintz:test:variant-error', e => {
      if (e.detail.sectionId !== sectionId) return;
      notice.textContent = 'Die gewählte Variante konnte nicht vollständig geladen werden. ';
      const link = document.createElement('a');
      link.href = window.location.href;
      link.textContent = 'Seite neu laden';
      notice.append(link);
      notice.hidden = false;
      root.querySelectorAll('.add_to_cart_button').forEach(button => {button.disabled = true;});
      root.querySelectorAll('.payment-button-container').forEach(box => {box.hidden = true; box.dataset.spVariantBlocked = '';});
    }, {signal:abort.signal});
    document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}`, () => {
      notice.hidden = true;
      root.querySelectorAll('[data-sp-variant-blocked]').forEach(box => {
        box.hidden = false;
        delete box.dataset.spVariantBlocked;
      });
    }, {signal:abort.signal});
    root.querySelectorAll('.x-block-buy-buttons input[name="quantity"]').forEach(input => {
      input.setAttribute('aria-label', 'Menge');
      const box = input.parentElement;
      box.querySelectorAll('button[name="minus"]').forEach(b => b.setAttribute('aria-label','Menge verringern'));
      box.querySelectorAll('button[name="plus"]').forEach(b => b.setAttribute('aria-label','Menge erhöhen'));
    });
  }
  function scan(scope=document) {scope.querySelectorAll('[data-sp-test-product]').forEach(init);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>scan(),{once:true});
  else scan();
  document.addEventListener('shopify:section:load',e=>scan(e.target));
  document.addEventListener('shopify:section:unload',e=>{
    e.target.querySelectorAll('[data-sp-test-product]').forEach(root=>{
      controllers.get(root)?.abort();controllers.delete(root);
    });
  });
})();
